import styled from 'styled-components';

const NewSlotFormStyles = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;

  .new-slot-form-card {
    width: 1000px;
    background-color: #f9f9f9;
    border-color: #f9f9f9;
    border-radius: 0;
  }

  .ant-input-affix-wrapper {
    height: 40px;
  }
`;

export default NewSlotFormStyles;
